import { mapActions, mapGetters } from "vuex";
import crumbs from "@/modules/card/components/crumbs/index.vue";
import { dynamicHead } from "../../mixins/dynamic-head";
export default {
    name: "categories-page",
    mixins: [dynamicHead],
    data() {
        return {
            meta: [],
            crumbs: [
                { title: "", name: "home", slug: "" },
                { title: this.$t("catalogProduct"), slug: "" },
            ],
        };
    },
    components: {
        crumbs,
    },

    computed: {
        ...mapGetters({
            categoryList: "category/childCategoryList",
            getCategories: "setting/menu",
        }),
    },
    watch: {
        "$route.params"(newVal) {
            if (newVal) {
                this.fethcChildCategory(this.$route.params.categorySlug);
            }
        },
        $route() {
            this.checkCategoryType();
            this.fethcChildCategory(this.$route.params.categorySlug).then(() => {
                this.crumbs = [
                    { title: "", name: "home", slug: "" },
                    { title: this.$t("catalogProduct"), slug: "" },
                ];
                if (this.categoryList.parent.title) {
                    this.crumbs.push({ title: this.categoryList.parent.title, slug: this.categoryList.parent.slug });
                }
                if (this.categoryList.title) {
                    this.crumbs.push({ title: this.categoryList.title, slug: this.categoryList.slug });
                }
            });
        },
        getCategories() {
            this.checkCategoryType();
        },
    },
    mounted() {
        this.checkCategoryType();
    },
    created() {
        this.fethcChildCategory(this.$route.params.categorySlug).then(response => {
            if (response["new-slug"]) {
                let head = document.querySelector("head");
                let routeObject = this.createRoute(response["new-slug"]);
                let link = this.$router.resolve(routeObject);
                if (!head.querySelector('[name="prerender-status-code"]')) {
                    head.innerHTML += `<meta name="prerender-status-code" content="301">`;
                    head.innerHTML += `<meta name="prerender-header" content="Location: ${window.location.origin}${link.href}">`;
                }
                this.$router.push(routeObject);
            }
            this.setPageItem(this.categoryList);
            if (this.categoryList.parent) {
                this.crumbs.push({ title: this.categoryList.parent.title, slug: this.categoryList.parent.slug });
            }
            if (this.categoryList) {
                this.crumbs.push({ title: this.categoryList.title, slug: this.categoryList.slug });
            }
        });
    },
    methods: {
        ...mapActions({
            fethcChildCategory: "category/GET_CHILD_CATEGORY",
        }),
        checkCategoryType() {
            const categoryValue = this.getAllCategoriesFromSlug();
            if (categoryValue.length === 0 && !!this.getCategories) {
                console.log('Category logic 3', typeof categoryValue[0]?.category === "undefined");
                this.$router.push({
                    name: "not-found-page",
                });
            }
            if (!!categoryValue[0] && categoryValue[0].category.childs.length === 0) {
                const link = this.$router.resolve(this.$linkwrap({name: "categories", params: this.$route.params, query: this.$route.query}));
                let head = document.querySelector("head");
                if (!head.querySelector('[name="prerender-status-code"]')) {
                    head.innerHTML += `<meta name="prerender-status-code" content="301">`;
                    head.innerHTML += `<meta name="prerender-header" content="Location: ${window.location.origin}${link.href}">`;
                }
                this.$router.push(
                    this.$linkwrap({
                        name: "categories",
                        params: this.$route.params,
                        query: this.$route.query,
                    })
                );
            }
        },
        createRoute(newSlug) {
            return {
                name: this.$route.name,
                params: {
                    geo: this.$route.params.geo,
                    lang: this.$route.params.lang,
                    categorySlug: newSlug,
                    filterSlug: this.$route.params.filterSlug,
                },
                query: { ...this.$route.query },
            };
        },
        getCategoryTypeFromSlug(slugValue = this.$route.params.categorySlug, categories = this.getCategories) {
            if (!!categories) {
                const searchCategories = (categories, isChild) => {
                    for (const category of categories) {
                        if (slugValue === category.slug) {
                            return isChild ? "child" : "main";
                        }
                        if (category.childs.length) {
                            const type = searchCategories(category.childs, true);
                            if (type) return type;
                        }
                    }
                    return null;
                };

                return searchCategories(categories, false);
            }
            return null;
        },

        getAllCategoriesFromSlug(slugValue = this.$route.params.categorySlug, categories = this.getCategories) {
            let found = [];

            const searchCategories = (categories, isChild) => {
                for (const category of categories) {
                    if (slugValue === category.slug) {
                        found.push(isChild ? {category: category, type: "child"} : {category: category, type: "main"});
                    }
                    if (category.childs.length) {
                        searchCategories(category.childs, true);
                    }
                }
            };

            if (categories) searchCategories(categories, false);
            return found;
        }
    },
};
